import React from "react";

export const FacebookIcon = () => {
  return (
    <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="35.3889" cy="35.3889" r="35.3889" fill="#3D5A96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7841 49.9072H31.3475V36.1956H28.1309V30.9117H31.3475V27.742C31.3475 23.4346 33.1636 20.8701 38.3234 20.8701H42.6188V26.154H39.935C37.9258 26.154 37.7922 26.8915 37.7922 28.2698L37.7841 30.9117H42.6494L42.0795 36.1956H37.7841V49.9072V49.9072Z"
        fill="white"
      />
    </svg>
  );
};
